import { OrganizationVideoAnalysisCallsUsageResponse } from "../../api-models/response/organization/OrganizationVideoAnalysisCallsUsageResponse";

export class SubscriptionVideoAnalysisCallsUsage {
  hasPaidSubscription: boolean;
  successfulVideoAnalysisCallsCount: number;
  totalVideoAnalysisCallsAvailable: number;
  billingCycleStartDate?: Date;
  billingCycleEndDate?: Date;

  constructor(
    subscriptionVideoAnalysisCallsUsageResponse?: OrganizationVideoAnalysisCallsUsageResponse
  ) {
    if (subscriptionVideoAnalysisCallsUsageResponse) {
      this.hasPaidSubscription = subscriptionVideoAnalysisCallsUsageResponse.hasPaidSubscription;
      this.successfulVideoAnalysisCallsCount =
        subscriptionVideoAnalysisCallsUsageResponse.successfulVideoAnalysisCallsCount;
      this.totalVideoAnalysisCallsAvailable =
        subscriptionVideoAnalysisCallsUsageResponse.totalVideoAnalysisCallsAvailable;
      this.billingCycleStartDate =
        subscriptionVideoAnalysisCallsUsageResponse.billingCycleStartDate;
      this.billingCycleEndDate = subscriptionVideoAnalysisCallsUsageResponse.billingCycleEndDate;
    } else {
      this.hasPaidSubscription = false;
      this.successfulVideoAnalysisCallsCount = 0;
      this.totalVideoAnalysisCallsAvailable = 0;
      this.billingCycleStartDate = undefined;
      this.billingCycleEndDate = undefined;
    }
  }
}
